import { TooltipIconType } from '../types/TooltipIconType'

export const tooltipIconColorMap: Record<TooltipIconType, string> = {
	[TooltipIconType.WARNING]: '--color-brand-200',
	[TooltipIconType.EXPIRED]: '--color-brand-200',
	[TooltipIconType.DOLLAR]: '--color-brand-200',
	[TooltipIconType.DEFAULT]: '--color-gray-400',
	[TooltipIconType.EXPIRING]: '--color-black',
	[TooltipIconType.SMILE]: '--color-black',
	[TooltipIconType.CUSTOM]: '--color-black'
}
